module.exports = __webpack_public_path__ + "media/Video 18.baa25b67.mp4";